import { CoBrowsingCompany } from '@customer-portal/shared/models';

import { CoBrowsingCompanyDto } from '../../dtos';

export class CoBrowsingMapperService {
  static mapToCoBrowsingCompanyList(
    dto: CoBrowsingCompanyDto[],
  ): CoBrowsingCompany[] {
    return dto.map((item: CoBrowsingCompanyDto) => ({
      label: `${item.companyName} - ${item.id}`,
      value: item.companyName,
      id: item.id,
      companyId: item.companyId,
    }));
  }
}
